import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface InfoCardStyles {
    wrapper?: InjectableCss;
}

export const styles: InfoCardStyles = {
    wrapper: {
        css: css`
            span {
                font-family: "Roboto-Regular" !important;
            }
            .rq-quote-wrapper,
            .ps-wrapper,
            .cs-wrapper,
            .return-wrapper {
                display: flex;
                justify-content: center;

                .rq-quote-container,
                .ps-container,
                .cs-container,
                .return-container {
                    width: 66.66667%;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    width: 100%;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                    form {
                        margin: auto;
                        margin-top: 30px;
                        padding: 30px;
                        background-color: #fff;
                        box-shadow: 0 1px 6px 1px rgba(133, 133, 133, 0.25);
                        display: flex;
                        flex-wrap: wrap;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        padding: 15px;
                                    `,
                                    null,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                        .hs-richtext {
                            margin: 15px 0;
                            max-width: 100%;
                            flex-basis: 100%;
                            padding: 0 10px;
                        }
                        .hs-fieldtype-text {
                            max-width: 50%;
                            flex-basis: 50%;
                            padding: 10px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        null,
                                        css`
                                            max-width: 100%;
                                            flex-basis: 100%;
                                        `,
                                        null,
                                        null,
                                    ],
                                    "max",
                                )}
                            .input {
                                > input {
                                    background: #ffffff;
                                    border: 1px solid #cccccc;
                                    border-radius: 0;
                                    padding: 0 10px 0 10px;
                                    height: 40px;
                                    background-color: #eaeaea;
                                    border: 1px solid transparent;
                                    box-shadow: none;
                                    font-size: 0.875rem;
                                    color: #000;
                                    margin-bottom: 0;
                                    transition: all 0.2s;
                                }
                                input:focus {
                                    border-color: #6d6e71;
                                    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                                }
                            }
                        }

                        .hs-error-msg {
                            font-size: 0.75rem;
                            font-weight: 600;
                            color: #e0182d;
                            padding-top: 5px;
                            margin-bottom: 0;
                            line-height: 1;
                        }
                        .hs-error-msgs {
                            list-style: none;
                            margin: 0;
                            background-color: #e0182d;
                            width: 100%;
                            height: 3px;
                            margin-bottom: 1.5rem;
                            transition: width 0.4s ease-in-out;
                        }
                        .hs-fieldtype-textarea {
                            max-width: 100%;
                            flex-basis: 100%;
                            padding: 10px;
                            .input {
                                > textarea {
                                    background: #ffffff;
                                    border: 1px solid #cccccc;
                                    border-radius: 0;
                                    padding: 10px;
                                    background-color: #eaeaea;
                                    border: 1px solid transparent;
                                    box-shadow: none;
                                    font-size: 0.875rem;
                                    color: #000;
                                    margin-bottom: 0;
                                    transition: all 0.2s;
                                    min-height: 100px;
                                    height: 2.5rem !important;
                                    text-align: left;
                                }
                                textarea:focus {
                                    border-color: #6d6e71;
                                    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                                }
                            }
                        }
                        .inputTitle {
                            > strong {
                                font-family: "Roboto-Medium" !important;
                            }
                        }
                        .hs_upload_parts_list_for_quote {
                            padding: 15px 10px;
                            width: 100%;
                            label {
                                margin-bottom: 5px;
                                display: block;
                            }
                            .input {
                                > input {
                                    font-size: 16px;
                                }
                            }
                        }
                        .hs_submit {
                            padding: 0 10px;
                            .hs-button {
                                height: 2.5em;
                                border-radius: 3px;
                                background-color: #a22e31;
                                display: inline-block;
                                font-family: inherit;
                                font-weight: 700;
                                font-size: 1em;
                                line-height: 100%;
                                padding: 0.7em 1.2em;
                                font-family: "Roboto-Medium";
                                text-decoration: none;
                                box-shadow: none;
                                border: 0;
                                text-align: center;
                                color: #fff;
                                margin-top: 15px;
                                background: ${getColor("primary")};
                            }
                        }
                        > div {
                            width: 100%;
                        }
                        .hs-fieldtype-date {
                            padding: 10px;
                            > label {
                                margin-bottom: 5px;
                                text-align: left;
                                display: inline-flex;
                            }
                            .input {
                                .hs-dateinput {
                                    > input {
                                        background: #ffffff;
                                        border: 1px solid #cccccc;
                                        border-radius: 0;
                                        padding: 0 10px 0 10px;
                                        height: 40px;
                                        background-color: #eaeaea;
                                        border: 1px solid transparent;
                                        box-shadow: none;
                                        font-size: 0.875rem;
                                        color: #000;
                                        margin-bottom: 0;
                                        transition: all 0.2s;
                                    }
                                    input:focus {
                                        border-color: #6d6e71;
                                        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                                    }
                                }
                            }
                        }
                        .hs_return_parts_file {
                            padding: 10px;
                            > label {
                                margin-bottom: 5px;
                                text-align: left;
                                display: block;
                            }
                            .input {
                                > .hs-input {
                                    font-size: 16px;
                                }
                            }
                        }
                    }
                    .hs_product_support_form_topic,
                    .hs_contact_us_standardelectric_form {
                        width: 100%;
                        padding: 10px;
                        > label {
                            margin-bottom: 5px;
                            text-align: left;
                            display: inline-flex;
                        }
                        ul {
                            list-style: none;
                            margin-left: 0;
                            margin-bottom: 0;
                            li {
                                margin-right: 10px;
                                display: inline-block;
                                width: 32%;
                                vertical-align: top;
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [
                                        css`
                                            width: 100%;
                                        `,
                                        css`
                                            width: 100%;
                                        `,
                                        css`
                                            width: 47%;
                                        `,
                                        css`
                                            width: 47%;
                                        `,
                                        null,
                                    ])}
                            }
                        }
                    }
                }
            }
            .news-wrapper,
            .news-letter-wrapper {
                width: 100%;
                max-width: 90rem;
                float: none;
                margin: auto;
                margin-bottom: 70px;
                form {
                    margin: auto;
                    margin-top: 30px;
                    padding: 30px;
                    background-color: #fff;
                    box-shadow: 0 1px 6px 1px rgba(133, 133, 133, 0.25);
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    padding: 15px;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "max",
                        )}
                    .hs_email {
                        margin-bottom: 1.1rem;
                        display: block;
                        > label {
                            margin-bottom: 5px;
                            text-align: left;
                            display: inline-flex;
                            font-weight: 600;
                        }
                        .input {
                            > input {
                                background: #ffffff;
                                border: 1px solid #cccccc;
                                border-radius: 0;
                                padding: 0 10px 0 10px;
                                height: 40px;
                                background-color: #eaeaea;
                                border: 1px solid transparent;
                                box-shadow: none;
                                font-size: 0.875rem;
                                color: #000;
                                margin-bottom: 0;
                                transition: all 0.2s;
                            }
                            input:focus {
                                border-color: #6d6e71;
                                box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                            }
                        }
                    }
                    .hs-submit {
                        .actions {
                            background: ${getColor("primary")};
                            border-radius: 3px;
                            .hs-button {
                                height: 2.5em;
                                border-radius: 3px;
                                background-color: #a22e31;
                                display: inline-block;
                                font-family: "Roboto-Medium";
                                font-size: 1em;
                                line-height: 100%;
                                padding: 0.7em 1.2em;
                                text-decoration: none;
                                box-shadow: none;
                                border: 0;
                                text-align: center;
                                color: #fff;
                                margin-top: 15px;
                                background: ${getColor("primary")};
                            }
                        }
                    }
                }
            }
            .news-letter-wrapper {
                margin-bottom: 0px !important;
                form {
                    margin-top: 20px !important;
                    display: flex;
                    box-shadow: none;
                    padding: 0;
                    position: relative;
                    .hs_email {
                        margin-bottom: 0 !important;
                    }
                    .hs_error_rollup {
                        position: absolute;
                        bottom: -23px;
                        font-size: 0.75rem;
                        font-weight: 600;
                        color: #e0182d;
                    }
                }
                .nw-heading {
                    color: ${getColor("primary")};
                    font-family: "Roboto-Medium";
                    font-size: 20px;
                }

                .hs-fieldtype-text {
                    label {
                        display: none !important;
                    }
                    .input {
                        width: 310px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        width: 100%;
                                    `,
                                    null,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                        > input {
                            background: #ffffff !important;
                            border: 1px solid #cccccc !important;
                            border-radius: 3px 0 0 3px !important;
                        }
                        input:focus {
                            border-color: #6d6e71;
                            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                        }
                    }
                }

                .hs-submit {
                    .actions {
                        background: ${getColor("primary")};
                        border-radius: 3px;
                        .hs-button {
                            border-radius: 0 3px 3px 0 !important;
                            background: ${getColor("primary")};
                            height: 40px !important;
                            margin-top: 0 !important;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        css`
                                            padding: 0 !important;
                                        `,
                                        null,
                                        null,
                                        null,
                                    ],
                                    "max",
                                )}
                        }
                    }
                }
            }
            .actions {
                display: inline-block;
                background: ${getColor("primary")};
                border-radius: 3px;
            }
            .hs-button {
                background: ${getColor("primary")};
                margin-top: 0 !important;
            }

            .hs-fieldtype-phonenumber {
                padding: 10px;
                .input {
                    > input {
                        background: #ffffff;
                        border: 1px solid #cccccc;
                        border-radius: 0;
                        padding: 0 10px 0 10px;
                        height: 40px;
                        background-color: #eaeaea;
                        border: 1px solid transparent;
                        box-shadow: none;
                        font-size: 0.875rem;
                        color: #000;
                        margin-bottom: 0;
                        transition: all 0.2s;
                    }
                    input:focus {
                        border-color: #6d6e71;
                        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                    }
                }
            }
            .hs-purchase_order_number {
                max-width: 100% !important;
                flex-basis: 100% !important;
                width: 100%;
                .input {
                    > input {
                        background: #ffffff;
                        border: 1px solid #cccccc;
                        border-radius: 0;
                        padding: 0 10px 0 10px;
                        height: 40px;
                        background-color: #eaeaea;
                        border: 1px solid transparent;
                        box-shadow: none;
                        font-size: 0.875rem;
                        color: #000;
                        margin-bottom: 0;
                        transition: all 0.2s;
                    }
                    input:focus {
                        border-color: #6d6e71;
                        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
                    }
                }
            }
        `,
    },
};

const HubspotContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Zone zoneName="Code Snippet" contentId={id} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: HubspotContainer,
    definition: {
        group: "Basic",
        displayName: "Hubspot Container",
    },
};

export default widgetModule;
